import { Box, SxProps, Theme, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import {
	emptyFavoriteProductFrameSX,
	emptyFavoriteProductIconSX,
	emptyFavoriteProductMessageSX,
	emptyFavoriteProductTitleSX,
} from '@/components/blocks/EmptyFavoriteProduct/styles';
import { combineSX } from '@/utils/combineSX';

interface Props {
	variant?: 'primary' | 'secondary';
	framesx?: SxProps<Theme>;
}

export const DpvaleEmptyCard: React.FC<Props> = ({ variant = 'secondary', framesx }) => (
	<Box
		sx={combineSX([
			emptyFavoriteProductFrameSX(variant),
			...(Array.isArray(framesx) ? framesx : [framesx]),
		])}
	>
		<FavoriteBorderIcon sx={emptyFavoriteProductIconSX} />
		<Typography sx={emptyFavoriteProductTitleSX}>{'¡Ups! Parece que está vacío'}</Typography>
		<Typography sx={emptyFavoriteProductMessageSX}>{'Aún no tienes dpvales activos'}</Typography>
	</Box>
);
